// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-image-viewer__mask{z-index:0}.el-image-viewer__canvas{position:relative;z-index:1}.el-image-viewer__btn{z-index:2}.el-image-viewer__raster-loading,.el-image-viewer__unknown{position:relative;z-index:1;color:#fff;font-size:14px;padding:24px;text-align:center}.el-image-viewer__unknown{max-width:480px;line-height:1.6}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
